import { DELIVERY_DATA_TRACKING_EVENTS, TDeliveryDataSelect, TDeliveryDataView } from './index';
import i18n, { defaultLang } from '@src/i18n';
import { trackByEvent } from '@src/tracking/services';
import { COMPONENT_TYPE } from '@src/tracking/constant';
import { useKeycloakUserState } from '@src/shared/context/keycloak-user';
export const useDeliveryDataTracking = () => {
  const { restaurant } = useKeycloakUserState();

  const trackDeliveryDataSelect = (component_action: string = '') => {
    const { component_name, component_type } = DELIVERY_DATA_TRACKING_EVENTS.deliveryData_select;

    const data: TDeliveryDataSelect = {
      component_name,
      component_type: component_type as COMPONENT_TYPE,
      component_action,
      eventCategory: '',
      country: restaurant?.country || '',
      language: i18n.language || defaultLang,
    };

    trackByEvent<TDeliveryDataSelect>('deliveryData_select', data);
  };

  const trackDeliveryDataView = (
    orders_tracked: string = '',
    custom_component_action: string = ''
  ) => {
    const { component_name, component_type, component_action } =
      DELIVERY_DATA_TRACKING_EVENTS.deliveryData_view;

    const data: TDeliveryDataView = {
      component_name,
      component_type: component_type as COMPONENT_TYPE,
      component_action: custom_component_action || component_action,
      eventCategory: '',
      orders_tracked,
      country: restaurant?.country || '',
      language: i18n.language || defaultLang,
    };

    trackByEvent<TDeliveryDataView>('deliveryData_view', data);
  };

  return {
    trackDeliveryDataSelect,
    trackDeliveryDataView,
  };
};
